import {
  differenceInCalendarDays,
  differenceInHours,
  differenceInMinutes,
  isSameDay,
  isSameYear
} from 'date-fns';

const customFormatForADay = (datePublished, dateRelativeTo, translate) => {
  const hoursDuration = differenceInHours(dateRelativeTo, datePublished);
  // if notification is sent less than an hour ago, timestamp will be displayed in minutes.
  if (hoursDuration < 1) {
    const minutesDuration = differenceInMinutes(dateRelativeTo, datePublished);
    return translate('Notification-Time-Minutes', { min: minutesDuration });
  }
  // if notification is sent more than an hour ago, timestamp will be displayed in hours.
  return translate('Notification-Time-Hours', { hour: hoursDuration });
};

export const formatRelativeDate = (
  datePublished,
  dateRelativeTo,
  date,
  translate,
  isAriaLabel
) => {
  const daysDuration = differenceInCalendarDays(dateRelativeTo, datePublished);
  if (isSameYear(datePublished, dateRelativeTo)) {
    // Case to handle notifications sent on the same day, Timestamp will be displayed in hours and minutes.
    if (isSameDay(datePublished, dateRelativeTo)) {
      return customFormatForADay(datePublished, dateRelativeTo, translate);
    }
    // Case to handle notifications sent in the same week
    if (daysDuration < 7) {
      // Case to handle notifications sent the day before current day, Timestamp will be displayed as yesterday.
      if (daysDuration === 1) {
        return translate('Yesterday-TimeStamp');
      }
      //  Case to handle notifications sent in the same week, Timestamp will be displayed as a weekday.
      return date(new Date(datePublished), {
        weekday: 'long'
      });
    }
  }
  // Timestamp will be displayed in full date format.
  if (isAriaLabel) {
    return date(new Date(datePublished), {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }
  return date(new Date(datePublished), {
    month: 'numeric',
    day: '2-digit',
    year: 'numeric'
  });
};
